<script>
import resources from './resources'

export default {
  name: 'index',
  mixins: [resources]
}
</script>

<template lang="pug">
  div
    div(v-show="showDetailsModal1")
      event-details(v-if="showDetailsModal1", :schedule-id="scheduleId")
    div(v-show="showDetailsModal2")
      |modal 2
    div
      .clearfix
      .col-xs-12
        .buttons-wrapper
          button.btn.save-filled(data-dismiss="modal", @click.prevent="doClose()")
            span.icon 
            |  Avaliar Estabelecimento
          button.btn.cancel-filled.hidden-sm.hidden-md.hidden-lg
            span.icon 
            |  Fechar

</template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/upcoming/components/index.vue